import { render, staticRenderFns } from "./TypeCertificateUserList.vue?vue&type=template&id=04e5cec0&scoped=true&"
import script from "./TypeCertificateUserList.vue?vue&type=script&lang=js&"
export * from "./TypeCertificateUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e5cec0",
  null
  
)

export default component.exports